'use client'
import { useEffect } from "react"
import useClickListener from "./useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"
import { sendGTMEvent } from '@next/third-parties/google'
import { send } from "process"

interface DatalayerClickManagerProps {
  hostname: string;
  locale: string;
  slug: string;
  siteName: string;
  environment: string;
}

export const DatalayerClickManager = ({
  hostname, 
  locale, 
  slug, 
  siteName, 
  environment
}: DatalayerClickManagerProps) => {
  
  const datalayerClickManager = (event:any) => {

    // Article social share
    if(event.target.closest('.react-share__ShareButton')) {
      const item = event.target.closest('.react-share__ShareButton')
      // console.log('Article social share')
      sendGTMEvent({
        event: "blog_article_social_share",
        sharing_platform: item.title || "",
        post_title: document?.querySelector("h1")?.textContent || "",
        post_url: window?.location?.href || "",
        post_length: document?.querySelector(".article-read-time")?.textContent || "",
        post_author: "", // authorsText,
        post_publish_date: document?.querySelector(".article-datestamp")?.textContent || "",
      })
    }

    // Language switcher
    if(event.target.closest('.t2-language-selector__body-footer-button')) {
      const item = event.target.closest('.t2-language-selector__body-footer-button')
      // console.log('Language switch click detected')
    }

    // Blog Switcher
    if(event.target.closest('.t2-blog-switcher__dropdown-container--title')) {
      const item = event.target.closest('.t2-blog-switcher__dropdown-container--title')
      // console.log('Blog Switch click detected')
    }

    // Blog Digest Featured Post
    if(event.target.closest('.t2-blog-digest__featured-posts__item')) {
      const item = event.target.closest('.t2-blog-digest__featured-posts__item')
      // console.log('Blog Digest Featured Post click detected', item)
      sendGTMEvent({
        event: "text_link_click",
        click_url: `${hostname}/${locale}/${siteName}/${slug}`,
        current_page: `${hostname}/${locale}/${siteName}/${slug}`,
        click_within_card: false,
        content_heading: "",
        content_eyebrow: "",
        content_section: "",
      })
    }
    // Blog Digest Latest Article
    if(event.target.closest('.t2-blog-digest__latest-article')) {
      const item = event.target.closest('.t2-blog-digest__latest-article')
      // console.log('Blog Digest Latest Post click detected', item)
      sendGTMEvent({
        event: "text_link_click",
        click_url: `${hostname}/${locale}/${siteName}/${slug}`,
        current_page: `${hostname}/${locale}/${siteName}/${slug}`,
        click_within_card: false,
        content_heading: "",
        content_eyebrow: "",
        content_section: "",
      })
    }

    // Grid Tabs
    if(event.target.closest('.react-tabs__tab')) {
      const item = event.target.closest('.react-tabs__tab')
      sendGTMEvent({
        event: "blog_subnav_click", // Grid Tab Click
        grid_tab_label: item.innerText,
        grid_tab_action: "click",
        current_page: `${hostname}/${locale}/${siteName}/${slug}`,
      })
    }

    // Grid Dropdown  - TODO
    // blog_filter_applied

    // Grid Cards
    if(event.target.closest('.t2-resource-grid__blog-cards .t2-terra-text-link')) {
      const item = event.target.closest('.t2-terra-text-link')
      sendGTMEvent({
        event: "grid_card_click",
        current_page: `${hostname}/${locale}/${siteName}/${slug}`,
      })
    }

    // Breadcrumbs
    if(event.target.closest('.t2-breadcrumbs-item')) {
      const item = event.target.closest('.t2-breadcrumbs-item')
      sendGTMEvent({
        event: "breadcrumb_click",
        // breadcrumb_label: linkText,
        breadcrumb_label: "linkText",
        breadcrumb_action: "expand",
      })
    }

    // Article Buttons
    if(event.target.closest('.article-cta .t2-button')) {
      const item = event.target.closest('.article-cta .t2-button')
      // console.log('Breadcrumb click detected', item)
    }

    // TODO: Navigation Clicks
    //  
    if(event.target.closest('.t2-site-navigation-main__nav-item')) {
      const item = event.target.closest('.t2-site-navigation-main__nav-item')
      // console.log('Nav Menu Top Level Item click detected', item)
      sendGTMEvent({
        event: "nav_click",
        click_label: item.textContent || "", // navLinkText, //label of navlink text
        click_url: item.href || null, //href,
        nav_location: "header", //'header','footer','left'
        nav_level: '1',
        x: "", // x,
        y: "", // y,
        total_nav_levels: null, // not sure about how to fetch this.
        featured_link: false, // isFeaturedLink,
        nav_path_english: null, // navPath,
      })
    }
    if(event.target.closest('.t2-site-navigation-main__subcategory-title')) {
      if(!event.target.classList.contains("t2-site-navigation-main__subcategory-title--no-children")) {
        const item = event.target.closest('.t2-site-navigation-main__subcategory-title')
        // console.log('Nav Menu Tier 2 Category click detected', item)
        sendGTMEvent({
          event: "nav_click",
          click_label: item.textContent || "", // navLinkText, //label of navlink text
          click_url: null, //href,
          nav_location: "header", //'header','footer','left'
          nav_level: '2',
          x: "", // x,
          y: "", // y,
          total_nav_levels: null, // not sure about how to fetch this.
          featured_link: false, // isFeaturedLink,
          nav_path_english: null, // navPath,
        })
      } else {
        const item = event.target.closest('.t2-site-navigation-main__subcategory-title--no-children a.t2-terra-text-link')
        // console.log('Nav Menu Tier 2 Link click detected', item)
        sendGTMEvent({
          event: "nav_click",
          click_label: item.textContent || "", // navLinkText, //label of navlink text
          click_url: item.href || null, //href,
          nav_location: "header", //'header','footer','left'
          nav_level: '2',
          x: "", // x,
          y: "", // y,
          total_nav_levels: null, // not sure about how to fetch this.
          featured_link: false, // isFeaturedLink,
          nav_path_english: null, // navPath,
        })
      }
    }
    if(event.target.closest('.t2-site-navigation-main__subcategory-item--overview')) {
      const item = event.target.closest('.t2-site-navigation-main__subcategory-item--overview')
      // console.log('Nav Menu Slide out Header', item)
      sendGTMEvent({
        event: "nav_click",
        click_label: item.textContent || "", // navLinkText, //label of navlink text
        click_url: item.href || null, //href,
        nav_location: "header", //'header','footer','left'
        nav_level: '3',
        x: "", // x,
        y: "", // y,
        total_nav_levels: null, // not sure about how to fetch this.
        featured_link: false, // isFeaturedLink,
        nav_path_english: null, // navPath,
      })
    }
    if(event.target.closest('.t2-site-navigation-main__subcategory-link')) {
      const item = event.target.closest('.t2-site-navigation-main__subcategory-link')
      // console.log('Nav Menu Slide out Item', item)
      sendGTMEvent({
        event: "nav_click",
        click_label: item.textContent || "", // navLinkText, //label of navlink text
        click_url: item.href || null, //href,
        nav_location: "header", //'header','footer','left'
        nav_level: '3',
        x: "", // x,
        y: "", // y,
        total_nav_levels: null, // not sure about how to fetch this.
        featured_link: false, // isFeaturedLink,
        nav_path_english: null, // navPath,
      })
    }
    if(event.target.closest('.t2-site-navigation-main__nav-promo-link')) {
      const item = event.target.closest('.t2-site-navigation-main__nav-promo-link')
      // console.log('Nav Menu Promo Link click detected', item)
      sendGTMEvent({
        event: "nav_click",
        click_label: item.textContent || "", // navLinkText, //label of navlink text
        click_url: item.href || null, //href,
        nav_location: "header", //'header','footer','left'
        nav_level: '3',
        x: "", // x,
        y: "", // y,
        total_nav_levels: null, // not sure about how to fetch this.
        featured_link: false, // isFeaturedLink,
        nav_path_english: null, // navPath,
      })
    }

    // 20/20 Image Compare
    if(event.target.closest('.image-compare')) {
      const item = event.target.closest('.image-compare')
      // console.log('Image Compare click detected', item)
    }

    // Article Tags
    if(event.target.closest('.article-tag')) {
      const item = event.target.closest('.article-tag')
      // console.log('Article Tag click detected', item)
    }

    // Footer TODO
    if(event.target.closest('.t2-footer__footer-menu__item')) {
      const item = event.target.closest('.t2-footer__footer-menu__item')
      // console.log('Footer Menu Item click detected', item)
      sendGTMEvent({
        event: "nav_click",
        click_label: item.textContent || "", // navLinkText, //label of navlink text
        click_url: item.href || null, //href,
        nav_location: "footer",
        nav_level: 1,
        total_nav_levels: 1,
      })
    }
    if(event.target.closest('.t2-footer__footer-menu__social-item a')) {
      const item = event.target.closest('.t2-footer__footer-menu__social-item a')
      // console.log('Footer Social Item click detected', item)
      sendGTMEvent({
        event: "nav_click",
        click_label: item.textContent || "", // navLinkText, //label of navlink text
        click_url: item.href || null, //href,
        nav_location: "footer",
        nav_level: 1,
        total_nav_levels: 1,
      })
    }
    if(event.target.closest('.t2-footer__global-footer__legal-stuff-link')) {
      const item = event.target.closest('.t2-footer__global-footer__legal-stuff-link')
      // console.log('Global Footer', item)
      sendGTMEvent({
        event: "nav_click",
        click_label: item.textContent || "", // navLinkText, //label of navlink text
        click_url: item.href || null, //href,
        nav_location: "footer",
        nav_level: 1,
        total_nav_levels: 1,
      })
    }
  }
  useClickListener(datalayerClickManager)

  return (
    <div className="datalayer-click-manager hidden hide"></div>
  )

}

export default DatalayerClickManager
